// @services/ReviewMetrics/ReviewMetricsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export interface DropoffStep {
  step_name: string
  users_reached: number
  abandoned_count?: number
  abandonedCount?: number
  dropoff_percentage: number
}

export interface DailyReviewCount {
  date: string
  count: number
}

export interface ReviewMetrics {
  conversion_rate: number
  median_time_seconds: number
  avg_optional_field_completion_rate: number
  started_count: number
  submitted_count: number
  dropoff_by_step: DropoffStep[]
  daily_review_counts: DailyReviewCount[]
}

export class ReviewMetricsService {
  async getReviewMetrics(dateRange?: { start?: string; end?: string }, reviewType?: string): Promise<ReviewMetrics | null> {
    const api = new ScrubstrApiQueryService()
    
    try {
      const params: Record<string, string> = {}
      
      if (dateRange?.start) {
        params.start_date = dateRange.start
      }
      
      if (dateRange?.end) {
        params.end_date = dateRange.end
      }
      
      if (reviewType) {
        params.review_type = reviewType
      }
      
      const data = await api.get<ReviewMetrics>({
        endpoint: 'admin/analytics/review-metrics',
        params: Object.keys(params).length > 0 ? params : undefined,
      })
      return data
    } catch (error) {
      console.error('Failed to fetch review metrics:', error)
      return null
    }
  }
}

